//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  mapState
} from 'vuex'
export default {
  name: "Header",
  props: ["title", "isShoppingcart", "hideBack"],
  computed: {
    ...mapState(["permissions"])
  },
  methods: {
    /*点击购物车*/
    goShoppingCart() {
      if (this.getPermissions(true) < 2) { //如果需要判断权限
        return;
      }
      this.openNewRouter("/shoppingcart")
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/template/Header.vue